<div class='input'>
  <mat-icon class='input__icon'>search</mat-icon>
  <input type='text' class='input__control' placeholder='Szukaj'>
</div>
